const { platform: systemPlatform, openPlatformProductKeys = {} } = window.self.SYSTEM_CONFIG || {};
const { productKey } = window.self.PAGE_PARAMS || {};
const isOpenPlatformChina = openPlatformProductKeys.china?.includes(productKey);
const isOpenPlatformAbroad = openPlatformProductKeys.abroad?.includes(productKey);

export default {
    //阿里云
    Aliyun: 'aliyun',
    //亚马逊
    Aws: 'aws',
    //国内开放平台
    OpenPlatformChina: 'OpenPlatformChina',

    isChina(platform = systemPlatform) {
        return [this.Aliyun, this.OpenPlatformChina].includes(platform) || isOpenPlatformChina;
    },
    /**
     * 是否是开放平台环境
     * @returns bool
     */
    isOpenPlatform() {
        //海外开放平台和blurams共用一套环境，只能使用pk来区分
        return isOpenPlatformChina || isOpenPlatformAbroad;
    }
};